export const getPISSummaryRoute = () => {
  return '/payinslip/summary';
};

export const getManagePISRoute = () => {
  return '/payinslip/manage';
};
